const { createBrowserHistory } = require("history");

const history = createBrowserHistory()

export default history